import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getContacts(params) {
        return Axios.get(`${baseURL}actor/contacts`, {
            params
        }).then(response => response.data.response);
    },
    getContactActor(actorId, params) {
        return Axios.get(`${baseURL}actor/contact/${actorId}`, { params }).then(
            response => response.data.response
        );
    },
    getContactCompany(companyId, params) {
        return Axios.get(`${baseURL}account/contact/${companyId}`, {
            params
        }).then(response => response.data.response);
    },
    getTotalActiveContacts() {
        return Axios.get(`${baseURL}report/contact/total_active_contacts`).then(
            response => response.data.response
        );
    },
    getTotalActiveCompanies() {
        return Axios.get(
            `${baseURL}report/contact/total_active_companies`
        ).then(response => response.data.response);
    },
    getNewContacts() {
        return Axios.get(`${baseURL}report/contact/new_contacts`).then(
            response => response.data.response
        );
    },
    deleteActorContact(contactId) {
        return Axios.delete(`${baseURL}actor/contact/${contactId}`).then(
            response => response.data.response
        );
    },
    deleteCompanyContact(contactId) {
        return Axios.delete(`${baseURL}account/contact/${contactId}`).then(
            response => response.data.response
        );
    },
    updateContactActor(params) {
        return Axios.put(`${baseURL}actor/contact/${params.id}`, params).then(
            response => response.data.response
        );
    },
    updateContactCompany(params) {
        return Axios.put(`${baseURL}account/contact/${params.id}`, params).then(
            response => response.data.response
        );
    },
    createContactActor(params) {
        return Axios.post(`${baseURL}actor/contact`, params).then(
            response => response.data.response
        );
    },
    createContactCompany(params) {
        return Axios.post(`${baseURL}account/company`, params).then(
            response => response.data.response
        );
    }
};
